import React from "react";
import {
  SoccerBall, Trophy, Medal, Crown, Shield, Fire, Lightning,
  Star, Target, Rocket, Diamond, Sparkle,
} from "@phosphor-icons/react";

import { parseAvatar } from "../lib/avatars";

const ICON_MAP = {
  ball:      SoccerBall,
  trophy:    Trophy,
  medal:     Medal,
  crown:     Crown,
  shield:    Shield,
  fire:      Fire,
  lightning: Lightning,
  star:      Star,
  target:    Target,
  rocket:    Rocket,
  diamond:   Diamond,
  sparkle:   Sparkle,
};

// Small, themeable avatar. Used in topbar, leaderboard, profile, admin table.
//   size = pixels
//   border = thin border around circle (useful on light backgrounds)
export const UserAvatar = ({ avatar, size = 32, border = false, testid }) => {
  const parsed = parseAvatar(avatar);
  const IconComponent = ICON_MAP[parsed.icon] || SoccerBall;
  const iconSize = Math.round(size * 0.55);
  return (
    <span
      data-testid={testid || "user-avatar"}
      title={`${parsed.label} ${parsed.icon}`}
      aria-label={`Avatar: ${parsed.label} ${parsed.icon}`}
      style={{
        width: size,
        height: size,
        backgroundColor: parsed.bg,
        color: parsed.fg,
        borderRadius: "9999px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: border ? "0 0 0 1px rgba(255,255,255,0.15)" : "none",
        flexShrink: 0,
      }}
    >
      <IconComponent size={iconSize} weight="fill" />
    </span>
  );
};

export default UserAvatar;
